import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NbDateService, NbTabComponent, NbTabsetComponent } from '@nebular/theme';
import { INgxSelectOption } from 'ngx-select-ex';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CountryData, CountryMst } from '../../../../@core/interfaces/masters/country';
import { Department, DepartmentData } from '../../../../@core/interfaces/masters/department';
import { DistrictData, DistrictMst } from '../../../../@core/interfaces/masters/district';
import { Physician, PhysicianData } from '../../../../@core/interfaces/masters/physician-mst';
import { StateData, StateMst } from '../../../../@core/interfaces/masters/state';
import * as gender from '../../../../data/gender.json';
import { MandatoryTemplate, MandatoryTemplateData } from '../../../../@core/interfaces/masters/mandatory-template';
import * as jobType from '../../../../data/jobtype.json';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { imageatch_det, imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';
import { TenantPackageData } from '../../../../@core/interfaces/masters/tenantpackage';
import { access } from '../../../../data/access-constants';
import { Location } from '@angular/common';
import * as countryCodeLists from '../../../../data/countryCode.json';
import * as honorifics from '../../../../data/honorifics-list.json';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'ngx-external-doctor-add',
  templateUrl: './external-doctor-add.component.html',
  styleUrls: ['./external-doctor-add.component.scss']
})
export class ExternalDoctorAddComponent implements OnInit {
  genderList: string[] = (gender as any).default;
  jobTypeList: string[] = (jobType as any).default;
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  protected readonly unsubscribe$ = new Subject<void>();
  physicianGrid: Array<any> = [];
  deptList: Department[];
  @Input() isAddComponnet: boolean = false;
  @Input() isEditComponnet: boolean = false;
  newPhyData: Physician;
  physicianForm: FormGroup;
  countriesList: CountryMst[];
  statesList: StateMst[];
  loadstatesList: StateMst[];
  districtsList: DistrictMst[];
  loadDistrictsList: DistrictMst[];
  imgFile: File;
  max: Date;
  placeholder: string = "Select";
  allowClear: boolean = true;
  multiple: boolean = false;
  isSubmitted: boolean = false;
  isBtnSubmitted: boolean = false;
  physicianId: string;
  doctorName: string;
  valueSet: string = "Dr. ";
  isAlreadyRegistered: boolean = false;
  mandaTempData: MandatoryTemplate[];
  pinReq: boolean = false;
  cityReq: boolean = false;
  districtReq: boolean = false;
  stateReq: boolean = false;
  countryReq: boolean = false;

  honorificsList: string[] = (honorifics as any).default;
  @ViewChild("tabSetRef") tabsetEl: NbTabsetComponent;
  pageTaskIds: any = [];
  private apiUrl = environment.apiUrl;
  userAccessData: any;
  isView: boolean = false;
  isEdit: boolean = false;
  isCreate: boolean = false;
  isPrint: boolean = false;
  isExport: boolean = false;
  private personal: Array<string> = ["pincode", "city", "district", "state", "country"];

  //
  isQueueView: Boolean = false;
  isQueuePrint: Boolean = false;
  //Book Appointment
  isBookAppointmentCreate: boolean = false;

  fileToUpload: any; //handled Object
  @ViewChild('myInput')
  myInputVariable: ElementRef;
  srcname: any = "../.././../../assets/images/userav.png"
  tenantPackageId: string;
  fileset: boolean = true;
  loadText = "Data Loading are in progress. Please wait";
  duplicatephysician: boolean;
  erroeSavemsg: boolean;
  savedSuccessMsg: boolean;

  prevEmail: string;
  prevMob: string;
  countryCodeDropDownLists: string[] = (countryCodeLists as any).default;
  mobileMinlength: number;
  mobileMaxlength: number;
  altMobileMinlength: number;
  altMobileMaxlength: number;
  private countryCode = localStorage.getItem('LoginCountryCode');
  @Input() directPhyName: string;
  @Output() closeExtPhyPopupEvent = new EventEmitter<string | number | null>();
  appointmentBookingTypeList:Array<any>=[];
  constructor(private location: Location,
    protected tenantpackageSrvc: TenantPackageData, protected mandatoryTempSrvc: MandatoryTemplateData, protected rolesService: RolesData,protected phySrvc: PhysicianData, protected deptSrvc: DepartmentData, protected dateService: NbDateService<Date>,
    protected stateSrvc: StateData, protected districtSrvc: DistrictData, private fb: FormBuilder, protected cntrySrvc: CountryData, protected domSanitizer: DomSanitizer, private iatchSrvc: imageatch_detData) {
    this.physicianForm = this.fb.group({
      isActive: this.fb.control(null),
      appointmentBookingType:this.fb.control(null,[Validators.required]),
      name: this.fb.control("Dr ", [Validators.required, Validators.pattern('^[a-zA-Z./,()\\s{1,}]+$')]),
      globalId: this.fb.control("12345"),
      gender: this.fb.control("Male", [Validators.required, Validators.pattern('^[A-Za-z0-9]+$')]),
      age: this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.min(23), Validators.maxLength(3)]),
      displayName: this.fb.control(null),
      dob: this.fb.control(null),
      email: this.fb.control(null, [Validators.required, Validators.email, this.emailDuplicateValidator]),
      workPhone: this.fb.control(null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(15)]),
      mobile: this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.maxLength(10), Validators.minLength(10), this.mobileDuplicateValidator]),
      altMobile: this.fb.control(null, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10), Validators.minLength(10)]),
      address: this.fb.control(null),
      streetName: this.fb.control(null),
      city: this.fb.control(null, [Validators.pattern('[a-zA-Z- ]*')]),
      districtId: this.fb.control(null),
      stateId: this.fb.control(null),
      countryId: this.fb.control(null),
      pincode: this.fb.control(null, [Validators.pattern('^[0-9]+$'), Validators.maxLength(6), Validators.minLength(6)]),
      panNo: this.fb.control(null, [Validators.pattern('^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}'), Validators.maxLength(10), Validators.minLength(10)]),
      departmentId: this.fb.control(null, [Validators.required]),

      jobType: this.fb.control(null, [Validators.required]),

      doctor: this.fb.control(this.valueSet),
      lastName: this.fb.control(null, [Validators.pattern('[^0-9]+$')]),
      mobileCountryCode: this.fb.control(this.countryCode),
      altMobileCountryCode: this.fb.control(this.countryCode),
      //Added New Column ***Thenmozhi***15 April 2022***
      newApptAmt: this.fb.control(null, [Validators.pattern('^[0-9-]+$')]),
      initiatedwhen: this.fb.control(null),
      apptGraceDays: this.fb.control(null, [Validators.pattern('^[0-9-]+$')]),
      apptGraceAmt: this.fb.control(null, [Validators.pattern('^[0-9-]+$')]),
      defaultLanguage: this.fb.control(null),
      englishAlongWithRegLang: this.fb.control(null),
      stockavailability: this.fb.control(null),

    }, { validators: mobileAndAltMobileValidator("mobile", "altMobile") });
  }
  async ngAfterViewInit() {
  }
  ngOnInit(): void {
    this.physicianForm.controls['mobileCountryCode'].setValue(this.countryCode);
    this.physicianForm.controls['altMobileCountryCode'].setValue(this.countryCode);
    this.physicianForm.controls["name"].setValue(this.directPhyName || '');
    this.physicianForm.controls["displayName"].setValue(this.directPhyName || '');

    this.physicianForm.controls["name"].valueChanges.subscribe((value: string) => {
      this.physicianForm.controls["displayName"].setValue(value);
    });
    this.physicianForm.controls["dob"].valueChanges.subscribe((value: string) => {
      if (!!value)
        this.rangeChangeEmitter(value);
    });
    this.physicianForm.controls['isActive'].setValue(true);
    this.max = this.dateService.addDay(new Date((this.dateService.getYear(this.dateService.today()) - 23), 12, 31), 0);
    this.loadMandatoryTemplate("Personal Details", this.personal);
    this.loadGeo();
    this.fetchPageAccess();
    this.loadDept();
    this.getTenantPackageId();
    console.log(this.physicianForm);
    this.setIntExtDynamicValidators();
    this.loadAppointmentBookingTypeMst()
  }
  loadAppointmentBookingTypeMst() {
    if(this.appointmentBookingTypeList.length==0){
    this.phySrvc.list(`area/getAppointmentBookingTypeMst`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        if (data && data.details) {
          this.appointmentBookingTypeList = data.details; // Assign the 'details' array to 'initiatedWhenList'
          this.physicianForm.controls["appointmentBookingType"].setValue(this.appointmentBookingTypeList[1].id);
       }
});
  }
}
  fetchPageAccess() {
    this.pageTaskIds = [];
    this.pageTaskIds.push(access.task.PHYMST, access.task.PHYCONFMST);
    let matrixSearchData = {
      taskId: this.pageTaskIds,
      UserId: localStorage.getItem("userType")
    }
    this.rolesService.create(`${this.apiUrl}/userrole/${this.tenandId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userAccessData = data;

    }, (error) => {
    }, () => {
      let View = this.userAccessData.filter(element => access.task.PHYCONFMST == element.taskID && element.permission == "true");
      if (View.length > 0) this.isView = true;
      let Create = this.userAccessData.filter(element => access.task.PHYMST == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
      if (Create.length > 0) this.isCreate = true;
      let Edit = this.userAccessData.filter(element => access.task.PHYMST == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
      if (Edit.length > 0) this.isEdit = true;
      let Print = this.userAccessData.filter(element => access.task.PHYMST == element.taskID && element.actionID == access.action.PRINT && element.permission == "true");
      if (Print.length > 0) this.isPrint = true;
      let Export = this.userAccessData.filter(element => access.task.PHYMST == element.taskID && element.actionID == access.action.EXPORT && element.permission == "true");
      if (Export.length > 0) this.isExport = true;


    });



  }

  onCountryCodeChange(code, type) {
    if (type == 'Mobile') {
      this.mobileMinlength = code[0]?.data?.phoneLength[0] || code[0]?.data.phoneLength;
      this.mobileMaxlength = code[0]?.data?.phoneLength[code[0]?.data?.phoneLength.length - 1] || code[0]?.data.phoneLength;
      this.physicianForm.get('mobile').setValidators([Validators.minLength(this.mobileMinlength), Validators.maxLength(this.mobileMaxlength)]);
      this.physicianForm.get('mobile').updateValueAndValidity();
    }
    else if (type == 'AltMobile') {
      this.altMobileMinlength = code[0]?.data?.phoneLength[0] || code[0]?.data?.phoneLength;
      this.altMobileMaxlength = code[0]?.data?.phoneLength[code[0]?.data?.phoneLength.length - 1] || code[0]?.data.phoneLength;
      this.physicianForm.get('altMobile').setValidators([Validators.minLength(this.altMobileMinlength), Validators.maxLength(this.altMobileMaxlength)]);
      this.physicianForm.get('altMobile').updateValueAndValidity();
    }
  }


  onAgeChge(event) {

    let date: Date = this.dateService.addDay(new Date((this.dateService.getYear(this.dateService.today()) - event.target.value), 0, 1), 0)

    this.physicianForm.controls["dob"].setValue('');
  }


  setIntExtDynamicValidators() {

    this.physicianForm.controls.mobile.clearValidators();
    this.physicianForm.controls.departmentId.clearValidators();
    this.physicianForm.controls.jobType.clearValidators();
    this.physicianForm.controls.email.clearValidators();

    this.physicianForm.controls.mobile.setValidators([
      Validators.pattern('^[0-9]+$'),
      Validators.maxLength(10),
      Validators.minLength(10),
      this.mobileDuplicateValidator
    ]);
    this.physicianForm.controls.email.setValidators([
      Validators.email,
      this.emailDuplicateValidator
    ]);

    this.physicianForm.controls.mobile.updateValueAndValidity();
    this.physicianForm.controls.departmentId.updateValueAndValidity();
    this.physicianForm.controls.jobType.updateValueAndValidity();
    this.physicianForm.controls.email.updateValueAndValidity();
  }
  getTenantPackageId() {

    this.tenantpackageSrvc.tenantList(`tenantPackage/GetTenantBranchDuplicate/${this.tenandId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((tenPackage: any) => {

      this.tenantPackageId = tenPackage[0].packageId;

    }, (error) => {

    }, () => {

    });

  }

  loadMandatoryTemplate(tabtiltle: string, fieldList: Array<string>): void {
    this.mandatoryTempSrvc.list(`mandatoryTemplate/${this.tenandId}/${this.branchId}/getMandatoryPageMstList?pageId=PG_DOC`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.mandaTempData = data?.details;
      fieldList?.forEach(list => {
        this.mandaTempData?.forEach(element => {
          if (element.requiredFieldId == list && element.mandatoryStatus == "Y") {
            var validatorValue = this.physicianForm.get(element.requiredFieldId).validator;
            if (validatorValue == null) {
              this.physicianForm.get(element.requiredFieldId).setValidators([Validators.required]);
            }
            else {
              this.physicianForm.get(element.requiredFieldId).setValidators([Validators.required, this.physicianForm.get(element.requiredFieldId).validator]);
            }
            this.physicianForm.get(element.requiredFieldId).updateValueAndValidity();
          }
        });
      });
    },
      (error) => {

      },
      () => {
        this.mandaTempData?.forEach(element => {
          if (element.mandatoryStatus == 'Y') {
            switch (element.requiredFieldId) {

              case 'pincode':
                this.pinReq = true;
                break;
              case 'city':
                this.cityReq = true;
                break;
              case 'districtId':
                this.districtReq = true;
                break;
              case 'stateId':
                this.stateReq = true;
                break;
              case 'countryId':
                this.countryReq = true;
                break;

              case 'default':
                break;

            }


          }
          else {
            switch (element.requiredFieldId) {

              case 'pincode':
                this.pinReq = false;
                break;
              case 'city':
                this.cityReq = false;
                break;
              case 'districtId':
                this.districtReq = false;
                break;
              case 'stateId':
                this.stateReq = false;
                break;
              case 'countryId':
                this.countryReq = false;
                break;


              case 'default':
                break;
            }
          }
        });

      });

  }



  get fval() { return this.physicianForm.controls; }


  trim(el, arg) {
    el = el.replace(/\s{2,}/g, ' ')

    this.physicianForm.controls[arg].setValue(el.trim());
  }

  loadGeo(): void {
    this.cntrySrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countriesList = data.value;
      this.stateSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.statesList = data.value;
        this.loadstatesList = data.value;
        this.districtSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.districtsList = data;
          this.loadDistrictsList = this.districtsList;
        }, (error) => {
        }, () => {
        });
      }, (error) => {
      }, () => {
      });
    }, (error) => {
    }, () => {
    });
  }
  loadDept(): void {
    this.deptSrvc.list(this.tenandId + '/' + "departments").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.deptList = data.value;
    }, (error) => {
    }, () => {
    });
  }


  onDistrictChge(event: INgxSelectOption[]): void {
    if (!!event) {
      this.physicianForm.controls["countryId"].setValue(event[0].data.countryId);
      this.physicianForm.controls["stateId"].setValue(event[0].data.stateId);
    }
    else {
      return;
    }
  }

  onClear(): void {
      this.physicianForm.reset();
      this.setIntExtDynamicValidators();
      this.isAddComponnet = false;
      this.isEditComponnet = false;
      this.isSubmitted = false;
      this.isBtnSubmitted = false;
      this.isAlreadyRegistered = false;
  }

  onReset(): void {
    this.physicianForm.reset();
    this.setIntExtDynamicValidators();
    this.isSubmitted = false;
    this.isBtnSubmitted = false;
    this.isAlreadyRegistered = false;

  }


  emailDuplicateValidator = (control: FormControl) => {
    var email = control.value;

    if (!email || control.pristine) {
      return null;
    }

    if (email.toLowerCase() === this.prevEmail?.toLowerCase()) {
      return null;
    }

    if (Array.isArray(this.physicianGrid)) {
      let email = this.physicianGrid.filter(x => x.email.toLowerCase() === control.value.toLowerCase());
      if (email.length > 0) {
        return { emailDuplicateValidator: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  mobileDuplicateValidator = (control: FormControl) => {
    var mobile = control.value;

    if (!mobile || control.pristine) {
      return null;
    }

    if (mobile === this.prevMob) {
      return null;
    }
    if (control.pristine) {
      return null;
    }
    if (this.physicianGrid.length > 0 && Array.isArray(this.physicianGrid)) {
      let mobile = this.physicianGrid.filter(x => x.mobile === control.value);
      if (mobile.length > 0) {
        return { mobileDuplicateValidator: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  onSave(args: { [key: string]: boolean | NbTabComponent }, event: any): void {



    this.isSubmitted = true;
    this.isBtnSubmitted = true;
    var trimedval = (this.physicianForm?.get('name')?.value)?.replace(/\s+/g, ' ')?.trim();
    if (this.physicianForm.valid && trimedval != "") {
      event.target.disabled = true;
      this.newPhyData = this.physicianForm.getRawValue();
      this.newPhyData.tenantId = this.tenandId;
      this.newPhyData.branchId = this.branchId;
      this.newPhyData.doctor = this.valueSet;
      this.newPhyData.createdBy = parseInt(localStorage.getItem("userId"));
      this.newPhyData.email = this.newPhyData?.email?.toLowerCase();
      this.newPhyData.mobile = (!this.physicianForm.get('mobile')?.value) ? '0000000000' : this.physicianForm.get('mobile')?.value;
      this.newPhyData.email = (!this.physicianForm.get('email')?.value) ? 'physician@gmail.com' : this.physicianForm.get('email')?.value;
      this.newPhyData.jobType = (!this.physicianForm.get('jobType')?.value) ? 'Consultant' : this.physicianForm.get('jobType')?.value;
      this.newPhyData.departmentId = (!this.physicianForm.get('departmentId')?.value) ? null : this.physicianForm.get('departmentId')?.value;
      this.newPhyData.referralType = 2;
      //***Added By Thenmozhi***
      this.newPhyData.englishAlongWithRegLang = this.physicianForm.get('englishAlongWithRegLang').value == true ? 'true' : 'false';
      this.newPhyData.medicineInfoFlag = this.physicianForm.get('stockavailability').value == true ? 'true' : 'false';

      this.newPhyData.createdDate = new Date();
      this.phySrvc.create(`physicians/${this.tenandId}/${this.branchId}/CreateExternalDoctor`, this.newPhyData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.physicianGrid = data.value;
        this.physicianId = data[data?.length-1]?.id;
        this.closeExtPhyPopupEvent.emit(data[data?.length - 1]?.id)
        if (!!this.fileToUpload) {
          const formData: FormData = new FormData();
          formData.set('fileKey', this.fileToUpload, data[data?.length-1]?.id + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1));

          let postData: imageatch_det = {
            tenantId: this.tenandId,
            branchId: this.branchId,
            containerName: this.tenandId,
            fileLocation: `${this.tenandId}/${this.branchId}/physician/${data[data?.length-1]?.id + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1)}`,
            fileName: data[data?.length-1]?.id + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1),
            category: "physician",
            createdDate: new Date(),
            createdBy: localStorage.getItem("userId"),
            phyId: data[data?.length-1]?.id,
            isCreate: this.isCreate,
            isEdit: this.isEdit,
            isView: this.isView,

          }
          for (const prop in postData) {
            if (!postData.hasOwnProperty(prop)) { continue; }
            formData.append(prop, postData[prop]);
          }

          this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/atch`, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            event.target.disabled = false;
            this.myInputVariable.nativeElement.value = "";

          }, (error) => {
            event.target.disabled = false;

          }, () => {

            event.target.disabled = false;
          });
        }

      }, (error) => {
        this.isSubmitted = false;
        this.isBtnSubmitted = false;
        if (error.status == 406) {
          this.isAlreadyRegistered = true;
          this.duplicatephysician = true;
          setTimeout(() => {
            this.duplicatephysician = false;
          }, 4000);
        }
        else {
          this.erroeSavemsg = true;
          setTimeout(() => {
            this.erroeSavemsg = false;
          }, 4000);
        }
      }, () => {
        this.isAlreadyRegistered = false;
        event.target.disabled = false;
        this.savedSuccessMsg = true;
        setTimeout(() => {
          this.savedSuccessMsg = false;
        }, 4000);
        if (args.continueToNext) {
          this.tabsetEl.selectTab(args.ref as NbTabComponent);
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
        }
        else {
          this.physicianForm.reset();
          this.imgFile = null;
          this.isAddComponnet = false;
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
          this.setIntExtDynamicValidators();
        }
      });
    }
    else {
      event.target.disabled = false;
      this.erroeSavemsg = true;
      setTimeout(() => {
        this.erroeSavemsg = false;
      }, 4000);
      this.isBtnSubmitted = false;
      return;
    }
  }
  isRequired(field: string): boolean {
    const control = this.physicianForm.get(field);
    if (!control) {
      return false;
    }
    const validator = control.validator({} as any);
    if (!validator) {
      return false;
    }
    return validator?.required;
  }
  rangeChangeEmitter(event: any): void {
    if (!!event) {
      var Difference_In_Time = Math.abs(Date.now() - new Date(event).getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
      this.physicianForm.controls['age'].setValue(Math.round(ageValue));
    }
  }

  handleFileInput(files: any) {
    if (this.isCreate || this.isEdit) {
      this.fileset = true;
      if (files.currentTarget.files.length > 0) {
        this.fileToUpload = files.currentTarget.files[0]
        const file = files.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.srcname = reader.result;
        reader.readAsDataURL(file);
      }
    }
    else {
      this.fileset = false;
    }
  }
}

export function mobileAndAltMobileValidator(mobile: string, altMobile: string): ValidationErrors | null {
  return (group: FormGroup) => {
    let mobileInput = group.controls[mobile];
    let altMobileInput = group.controls[altMobile];
    if (mobileInput.value === altMobileInput.value && altMobileInput.value !== "" && altMobileInput.value !== undefined && altMobileInput.value !== null) {
      return { equivalent: true }
    }
    else {
      return null
    }
  }


}

